module.exports = __webpack_public_path__ + "static/Platze_Ubersicht-596ab556e7972dcb855311d6226ce1cd.jpg";